
import {
  ADD_PLANT_SUCCESS,
  ADD_PLANT_TOGGLE_MODAL,
} from './actions';

const initialState = {
  modal: false,
};

function AddPlantReducer(state = initialState, actions) {
  switch(actions.type) {
    case ADD_PLANT_TOGGLE_MODAL:
      return {
        ...state,
        modal: actions.modal
      };
    case ADD_PLANT_SUCCESS:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
}

export default AddPlantReducer;
